export const sidebarVars = {
  gap: 8,
  padding: {
    branches: 22,
    ends: 6,
    sides: 8,
  },
  width: {
    minimized: {
      mouse: 46,
      touch: 52,
    },
    maximized: {
      mouse: 212,
      touch: 240,
    },
  },
};
